import type { ComponentType } from "react";

import { cn } from "../../utils";

export interface OpenaiYamlDependenciesEmptyCardProps {
  icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
}

export const OpenaiYamlDependenciesEmptyCard = ({
  icon: Icon,
  title,
  description,
}: OpenaiYamlDependenciesEmptyCardProps) => (
  <div className="ml-3">
    <div
      className={cn(
        "w-full border border-gray-200/80 bg-white text-center shadow-sm shadow-gray-950/5",
        "max-w-none rounded-2xl px-4 py-5",
      )}
    >
      <div className="flex flex-col items-center text-center">
        <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 text-gray-400">
          <Icon className="h-5 w-5" />
        </div>
        <p className="text-base font-medium text-gray-900">{title}</p>
        <p className="mt-1.5 max-w-xs text-sm leading-6 text-gray-500">{description}</p>
      </div>
    </div>
  </div>
);
